import { validationMixin } from 'vuelidate';
import httpStatuses from 'http-status-codes';

export default {
    mixins: [validationMixin],
    data() {
        return {
            serverErrors: {}
        };
    },
    computed: {
        isValid() {
            return !this.$v.$invalid;
        }
    },
    methods: {
        checkForServerFormErrors(error) {
            if (!error.response) {
                return false;
            }

            if (error.response.status === httpStatuses.INTERNAL_SERVER_ERROR) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('formCommonErrors.commonTitle'),
                    text: this.$t('formCommonErrors.serverError')
                });

                return false;
            }

            if (
                [
                    httpStatuses.FORBIDDEN,
                    httpStatuses.BAD_REQUEST,
                    httpStatuses.UNPROCESSABLE_ENTITY
                ].includes(error.response.status)
            ) {
                error.response.data.errors.map(error => {
                    if (this.serverErrors[error.param]) {
                        this.serverErrors[error.param] = [];
                        this.serverErrors[error.param].push(error.message);
                    }
                });

                return true;
            }

            if (error.response.status === httpStatuses.NOT_FOUND) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('formCommonErrors.commonTitle'),
                    text: this.$t('formCommonErrors.resourceNotExists')
                });
            }

            return false;
        },
        clearServerErrors(type) {
            this.serverErrors[type] = [];
        },
        checkServerErrors(inputName) {
            const errors = [],
                serverErrors = this.serverErrors[inputName];

            serverErrors.length &&
                serverErrors.forEach(err => errors.push(err));

            return errors;
        },
        checkRequired(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.required &&
                errors.push(this.$t(translatePrefix + inputName + 'Required'));

            return errors;
        },
        checkNumeric(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.numeric &&
                errors.push(this.$t(translatePrefix + inputName + 'Numeric'));

            return errors;
        },
        checkEmail(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.email &&
                errors.push(this.$t(translatePrefix + inputName + 'Valid'));

            return errors;
        },
        checkLength(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            (!input.minLength || !input.maxLength) &&
                errors.push(
                    this.$t(translatePrefix + inputName + 'Length', {
                        min: input.$params.minLength.min,
                        max: input.$params.maxLength.max
                    })
                );

            return errors;
        },
        checkSameAsPassword(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.sameAsPassword &&
                errors.push(
                    this.$t(translatePrefix + inputName + 'SameAsPassword')
                );

            return errors;
        },
        checkContainNoWeekendDays(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.containNoWeekendDays &&
                errors.push(
                    this.$t(
                        translatePrefix + inputName + 'ContainNoWeekendDays'
                    )
                );

            return errors;
        },
        checkContainNoHolidays(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.containNoHolidays &&
                errors.push(
                    this.$t(translatePrefix + inputName + 'ContainNoHolidays')
                );

            return errors;
        },
        checkEndDateIsAfterStartDate(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            !input.endDateIsAfterStartDate &&
                errors.push(
                    this.$t(
                        translatePrefix + inputName + 'EndDateIsAfterStartDate'
                    )
                );

            return errors;
        },

        checkErrors(
            inputName,
            formName = 'formData',
            translatePrefix = this.$options.name + '.validators.'
        ) {
            let errors = [],
                input;

            if (this.$v[formName]) {
                input = this.$v[formName][inputName];
            } else {
                input = this.$v[inputName];
            }

            if (!input.$dirty) {
                return errors;
            }

            if (input.$params.numeric) {
                errors = errors.concat(
                    this.checkNumeric(inputName, formName, translatePrefix)
                );
            }

            if (input.$params.required) {
                errors = errors.concat(
                    this.checkRequired(inputName, formName, translatePrefix)
                );
            }

            if (input.$params.email) {
                errors = errors.concat(
                    this.checkEmail(inputName, formName, translatePrefix)
                );
            }

            if (input.$params.minLength || input.$params.maxLength) {
                errors = errors.concat(
                    this.checkLength(inputName, formName, translatePrefix)
                );
            }

            if (input.$params.sameAsPassword) {
                errors = errors.concat(
                    this.checkSameAsPassword(
                        inputName,
                        formName,
                        translatePrefix
                    )
                );
            }

            if (input.$params.containNoWeekendDays) {
                errors = errors.concat(
                    this.checkContainNoWeekendDays(
                        inputName,
                        formName,
                        translatePrefix
                    )
                );
            }

            if (input.$params.containNoHolidays) {
                errors = errors.concat(
                    this.checkContainNoHolidays(
                        inputName,
                        formName,
                        translatePrefix
                    )
                );
            }

            if (input.$params.endDateIsAfterStartDate) {
                errors = errors.concat(
                    this.checkEndDateIsAfterStartDate(
                        inputName,
                        formName,
                        translatePrefix
                    )
                );
            }

            errors = errors.concat(this.checkServerErrors(inputName));

            return errors;
        }
    }
};
